import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { secondaryButtonClasses } from "@/constants/ui";
import { useCancelBookingDialog } from "../useCancelBookingDialog";

export const ResultScreen = () => {
  const { result, onClose } = useCancelBookingDialog();
  const charged = result?.wasCharged;
  return (
    <div data-testid="cancel-dialog-result" className="w-full flex flex-col items-center text-center bg-white rounded-xl my-4 p-8 gap-4">
      <CheckCircle2 className="w-16 h-16 text-green-600" />
      <h2 className="text-2xl font-semibold text-green-900">Cancelled</h2>
      <p data-testid="cancel-result-message" className="text-sm text-gray-600 max-w-md">
        {charged
          ? "You will be charged for this cancellation because it is within 24 hours of the booking."
          : "We have successfully cancelled your booking."}
      </p>
      <Button data-testid="cancel-done" variant="outline" className={`mt-2 ${secondaryButtonClasses}`} onClick={onClose}>Done</Button>
    </div>
  );
};
